import { ref, toValue } from 'vue';
export function useDataGridExpansion(options = {}) {
    const getKey = () => toValue(options.itemKey) ?? 'Id';
    // Internal Set for tracking expanded keys (used by EnDataGrid / local state)
    const expandedRows = ref(new Set());
    function isExpanded(item) {
        const key = getKey();
        const itemKeyValue = item?.[key];
        const currentExpandedItems = toValue(options.expandedItems);
        if (currentExpandedItems !== undefined) {
            return currentExpandedItems.some((i) => i[key] === itemKeyValue);
        }
        return expandedRows.value.has(itemKeyValue);
    }
    function toggleExpand(item) {
        const key = getKey();
        const itemKeyValue = item?.[key];
        const isSingle = toValue(options.singleExpand);
        const currentExpandedItems = toValue(options.expandedItems);
        if (currentExpandedItems !== undefined) {
            const current = [...currentExpandedItems];
            const index = current.findIndex((i) => i[key] === itemKeyValue);
            if (index > -1) {
                current.splice(index, 1);
            }
            else {
                if (isSingle) {
                    current.length = 0;
                }
                current.push(item);
            }
            options.onUpdateExpandedItems?.(current);
            return;
        }
        // Set-based mode
        if (expandedRows.value.has(itemKeyValue)) {
            expandedRows.value.delete(itemKeyValue);
        }
        else {
            if (isSingle) {
                expandedRows.value.clear();
            }
            expandedRows.value.add(itemKeyValue);
        }
    }
    return {
        expandedRows,
        isExpanded,
        toggleExpand,
    };
}
